module.exports = __webpack_public_path__ + "static/media/email.da2dd1b5.svg";